import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import EconomicIndicesManager from '../../components/subscriptions/EconomicIndicesManager';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const EconomicIndicesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full px-6 py-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-extrabold">Índices Econômicos</h1>
          <p className="text-muted-foreground">
            Gerencie os índices econômicos (IGPM e IPCA) para ajuste de preços de assinaturas
          </p>
        </div>
        <div className="flex space-x-2">
          <Button variant="outline" onClick={() => navigate('/subscriptions')} className="gap-1.5">
            Voltar para Assinaturas
          </Button>
        </div>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle>Índices Econômicos</CardTitle>
          <CardDescription>
            IGPM e IPCA utilizados para ajustes de preços
          </CardDescription>
        </CardHeader>
        <CardContent>
          <EconomicIndicesManager />
        </CardContent>
      </Card>
    </div>
  );
};

export default EconomicIndicesPage; 